import React from 'react'
import { observer } from 'mobx-react-lite'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'

import { H3 } from '@mxenabled/mxui'

import { ANALYTICS_EVENTS, useBudgetsStore, useEvent, useGlobalCopyStore } from '../../common'
import { type DetailedBudget } from '../../core'

import { BudgetRow } from './budgetlist/BudgetRow'

export const BudgetList = observer(() => {
  const { onEvent } = useEvent()
  const { budgets: copy } = useGlobalCopyStore()
  const { detailedBudgets: budgets, setSelectedBudget } = useBudgetsStore()

  const handleBudgetClick = (budget: DetailedBudget) => {
    setSelectedBudget(budget)
    onEvent(ANALYTICS_EVENTS.BUDGETS_CLICK_BUDGET_CATEGORY, {
      budget_category: budget.category.name,
      click_type: 'list',
    })
  }

  return (
    <Card elevation={2}>
      <CardHeader sx={{ pb: 8, pl: 24 }} title={<H3>{copy.budget_categories_title}</H3>} />
      <CardContent sx={{ p: 0, ':last-child': { p: 0 } }}>
        <List>
          {budgets.map((budget) => (
            <React.Fragment key={budget.guid}>
              <BudgetRow budget={budget} onClick={handleBudgetClick} />
              <Divider />
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  )
})
